module.exports = __webpack_public_path__ + "static/img/bg-saveposter-create.63a2d12d.png";